export const TotalAmount = (data, field) => {
  let total = 0;
  if (data) {
    for (let i = 0; i < data.length; i++) {
      let obj = data[i];

      if (obj[field] !== undefined && field === "Amt") {
        total = parseInt(total) + parseInt(obj[field]);
      } else if (obj["Amount"] !== undefined) {
        total = parseInt(total) + parseInt(obj["Amount"]);
      } else {
        total = parseInt(total) + parseInt(obj["LinkAmount"]);
      }
    }
  }

  return total;
};
